// Global types are automatically included via tsconfig.json
import axios from "axios"
import { FpiMemO28 } from "./modules/fpiMemO28"
import { Front } from "./modules/front"

// Rendo axios disponibile globalmente
;(window as any).axios = axios

/**
 * Frontend Application entry point
 * Gestisce l'inizializzazione dei moduli in base alla pagina corrente
 */
class FrontApp {
  private modules: Map<string, any> = new Map()

  constructor() {
    console.log("Frontend Application starting...")
    this.registerModules()
    this.init()
  }

  /**
   * Registra tutti i moduli disponibili
   */
  private registerModules(): void {
    this.modules.set("fpi_mem028", FpiMemO28)
    this.modules.set("front", Front)
    // Aggiungi qui altri moduli futuri per il frontend
  }

  /**
   * Inizializza l'applicazione
   */
  private init(): void {
    document.addEventListener("DOMContentLoaded", () => {
      this.initializeCurrentPageModule()
    })
  }

  /**
   * Inizializza il modulo specifico per la pagina corrente
   */
  private initializeCurrentPageModule(): void {
    const currentPage = this.detectCurrentPage()
    console.log("Current frontend page detected:", currentPage)

    const ModuleClass = this.modules.get(currentPage)
    if (ModuleClass) {
      const moduleInstance = new ModuleClass()
      moduleInstance.init()
      console.log(`${currentPage} module initialized`)
    } else {
      console.log("No specific module found for current page, using default front module")
      // Inizializza il modulo front di default
      const frontModule = new Front()
      frontModule.init()
    }
  }

  /**
   * Rileva la pagina corrente basandosi su vari fattori
   */
  private detectCurrentPage(): string {
    // Rileva dall'URL
    const path = window.location.pathname
    const segments = path.split("/").filter(segment => segment.length > 0)

    // Controlla se fpi_mem028 è presente nell'URL
    if (segments.includes("fpi_mem028")) {
      return "fpi_mem028"
    }

    // Rileva dal body class
    const bodyClasses = document.body.className.split(" ")
    for (const cls of bodyClasses) {
      if (this.modules.has(cls)) {
        return cls
      }
    }

    // Salta "front" se presente nell'URL e cerca altri segmenti
    const relevantSegments = segments.filter(segment => segment !== "front")

    for (const segment of relevantSegments) {
      if (this.modules.has(segment)) {
        return segment
      }
    }

    // Rileva da elementi specifici nella pagina
    if (document.querySelector(".container-fpi_mem028")) {
      return "fpi_mem028"
    }

    if (document.getElementById("contact-form")) {
      return "contact"
    }

    if (document.getElementById("search-form")) {
      return "search"
    }

    // Default fallback
    return "front"
  }

  /**
   * Metodo per registrare dinamicamente un modulo
   */
  public registerModule(name: string, moduleClass: any): void {
    this.modules.set(name, moduleClass)
    console.log(`Module '${name}' registered`)
  }

  /**
   * Getter per accedere ai moduli registrati
   */
  public getModules(): Map<string, any> {
    return this.modules
  }
}

// Inizializzo l'applicazione frontend
new FrontApp()

// Esporto per uso globale se necessario
export { FrontApp }
